import React from 'react'
import { Link, useLocation } from 'react-router-dom';
import Footer from '../../../../Layout/Footer';
import Header from '../../../../Layout/Header';
import feedback from '../../../../../assets/img/notify.jpg';
import { useState } from 'react';
import { useEffect } from 'react';
import { getOfferBuyer, getOfferSeller } from '../../../../../Redux/Task/action';
import { IMAGE_URL } from '../../../../../api';
import { BiRupee } from 'react-icons/bi';

const MytaskAssignHistory = () => {
    const { state } = useLocation();
    // const [tasks, setTasks] = useState([])
    // useEffect(() => {
    //     getOfferSeller()((response) => {
    //         if (response && response.status) {
    //             setTasks(response?.data?.data)
    //         }
    //     });
    // }, []);
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>My Task </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Task Details</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="mytask-details">
                <div className="container">
                    <div className="row task-history-main">
                        <div className="member">
                            <div className="pic"><img src={IMAGE_URL + state?.data?.image?.image} className="img-fluid" alt="" /></div>
                            <div className="member-info">
                                <h4>{state?.data?.assigned_to?.full_name}</h4>
                                {state?.data?.avg_rating == "" ?
                                    <></>
                                    :
                                    <p>{parseFloat(state?.data?.avg_rating).toFixed(1)} <i class="bi bi-star-fill"></i> Rating ({state?.data?.total_rating}) </p>
                                }
                            </div>

                        </div>
                        <div className='member-details'>
                            {state?.data?.image?.experience &&
                                <h4>Experience: {parseFloat(state?.data?.image?.experience).toFixed(1)}</h4>
                            }
                            {state?.data?.image?.about_user &&
                                <h4>Bio: {state?.data?.image?.about_user}</h4>
                            }
                            <h4>Customer Rating:</h4>
                            {state?.data?.seller_review?.map((task, index) => (
                                <React.Fragment>
                                    {/* {state?.map((review, index) => (
                                        <div className='border-bottom-experience'>
                                            <span className="badge badge-light-warning">{parseFloat(state?.data?.seller_review[0]?.rating).toFixed(1)} <i class="bi bi-star-fill"></i></span>
                                            <p className='mt-2'>{state?.data?.seller_review[0]?.comment}</p>
                                        </div>
                                    ))

                                    } */}
                                    <div className='border-bottom-experience'>
                                        <span className="badge badge-light-warning">{parseFloat(task?.rating).toFixed(1)} <i class="bi bi-star-fill"></i></span>
                                        <p className='mt-2'>{task?.comment}</p>
                                    </div>
                                </React.Fragment>
                            )

                            )}
                        </div>
                        <div className=''>
                            <div className='service-history'>
                                <div className='member-details-left'>
                                    <h4>Service History</h4>
                                </div>
                            </div>
                        </div>
                        {state?.data?.seller_history?.map((task, index) => (
                            <React.Fragment>
                                {/* {task?.service_history?.map((service, index) => (
                                    <div className='member-details-hist'>
                                        <div className='service-history'>
                                            <div className='member-details-left'>
                                                <h4>Service History</h4>
                                                <p>{service?.task_details?.title}</p>
                                                <p>Buyer: {service?.user_data[0]?.username}</p>
                                                <p>{service?.task_details?.description}</p>
                                            </div>
                                            <div className='member-details-right'>
                                                <p className='bid-rate'>Bid rate: {service?.task_details?.task_price}</p>
                                                <p className='completed'><i class="bi bi-check-circle"></i> Completed</p>
                                            </div>
                                        </div>

                                    </div>
                                ))

                                } */}
                                <div className='member-details-hist'>
                                    <div className='service-history'>
                                        <div className='member-details-left'>
                                            <h3>{task?.task_details?.title}</h3>
                                            <p>Buyer: {task?.user_data[0]?.username}</p>
                                            <p>{task?.task_details?.description}</p>
                                        </div>
                                        <div className='member-details-right'>
                                            <p className='bid-rate'>Bid rate: <BiRupee size="20" style={{ color: "#000" }} />{task?.task_details?.task_price}</p>
                                            <p className='completed'><i class="bi bi-check-circle me-2"></i> Completed</p>
                                        </div>
                                    </div>

                                </div>
                            </React.Fragment>
                        )

                        )}
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default MytaskAssignHistory;